(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function ($) {
        Site.run();

        var $keepalive = $('#keepalive');


        if ($keepalive.length){

            var interval = $keepalive.data('interval');
            var url = $keepalive.data('url');
            var time = $keepalive.data('time');

            var keepAlive = function(){
                $.post(url, {time:time})
                    .done(function(data){
                        if (data.time!=undefined) time= data.time;
                        checkResponse(data);
                    })

                    .always(function(){
                        setTimeout(keepAlive,interval);
                    })
            };

            setTimeout(keepAlive,interval);

            //$('#notification_icon').click(function(e){
            //    $.post(url, {time:time, action:"clearunread"})
            //        .done(function(data){
            //            checkResponse(data);
            //        })
            //});


        }

        $(document).on('click','[data-mark-notification]', function(e){

            $.post(url, {time:time, action:"clearunread"})
                .done(function(data){
                    checkResponse(data);
                });

            if (navigator.setAppBadge) {
                navigator.clearAppBadge();
            }
        });

        var checkResponse = function(data){
            if (data.unread !=undefined) updateUnread(data.unread);
            if (data.notifications !=undefined) updateNotifications(data.notifications);
            if (data.notify !=undefined) window.renotify(data.notify);
        };




        var updateUnread = function (nr)
        {
            var $nnc = $('#nr_notification_count');
            if (nr == 0) {
                $nnc.addClass('hidden');
            }else{
                $nnc.text(nr);
                $nnc.removeClass('hidden');
            }
        }


        var countDownUnread = function(){
            var $nnc = $('#nr_notification_count');
            var nr =  parseInt($nnc.text());
            if (nr) nr--;
            updateUnread(nr);
        }

        var updateNotifications = function(notifications)
        {
            var $nc = $('#front_notifications');
            $nc.html(notifications);
        }


        $(document).on('click','.notification-box', function(e){

            var id = $(this).data('id');
       // $('.notification-box').on('click', function(){
            if ($(this).hasClass('notread')){
                $('.notification-'+id).removeClass('notread');
                countDownUnread();
            }

            if ($(this).data('type') == 'slidePanel') {
                window.removeTooltips();
                var url = $(this).data('url');
                window.addToSlideHistory(url);
                openSlide(url);
                e.stopPropagation();
                e.preventDefault();
            }
        });






    })
})(document, window, jQuery);